export const realityId = Number(import.meta.env.VITE_REALITY_ID);
